<template>
  <div class="backside" @click="$emit('exitInfo')">
    <transition name="info-left">
      <div v-if="showinfo" class="mb-info-left-curtain" @click="$emit('exitInfo')">
        <div
          v-if="showinfo"
          id="exit"
          @click="$emit('exitInfo')"
          width="calc(1080px * 0.05)"
          height="calc(1080px * 0.05)"
          :style="{ 'background-color': infopage.cssStyle.primaryColor }"
        >
          <svg viewBox="0 0 24 24">
            <path
              stroke-linejoin="round"
              stroke-linecap="round"
              d="M8,8 16,16z M8,16 16,8z"
              stroke="white"
              stroke-width="3"
            />
          </svg>
        </div>
      </div>
    </transition>
    <transition name="info-right">
      <div
        v-if="showinfo"
        class="mb-info-right-curtain"
        @click.stop
        :style="{ 'background-color': infopage.cssStyle.primaryColor }"
      >
        <div class="content" :style="infopage.cssStyle">
          <div class="header"></div>
          <div class="people" v-for="(person, i) in infopage.people" :key="i" :style="person.cssStyle">
            <hr v-if="!person.hideLine" />
            <h4 class="title" :style="person.tcssStyle" v-html="person.title"></h4>
            <h4 class="name" :style="person.ncssStyle" v-html="person.name"></h4>
          </div>

          <div class="texts">
            <div
              v-for="(text, i) in infopage.texts"
              :key="i"
              class="text"
              :style="text.cssStyle"
              v-html="text.text"
            ></div>
          </div>
          <!-- {{ infopage }} -->
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'infobox',
  props: { infopage: { type: Object }, showinfo: { type: Boolean } },
};
</script>

<style lang="scss">
.backside {
  //position: fixed;
  //width: 100%;
  //height: 100%;
  //cursor: pointer;
  //backdrop-filter: blur(3px);
  //
  //z-index: 17;
  //font-family: Celias !important;
  //display: block;
  //overflow: hidden;
  font-family: Celias !important;
  background: #e6007e;
  color: #ffffff;
  display: block;
  overflow: hidden;

  .mb-info-left-curtain {
    width: 50%;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 24;
    background: #00000080;
    position: fixed;
    ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }
    ::-webkit-scrollbar {
      width: 10px;
    }
  }
  .mb-info-right-curtain {
    ::-webkit-scrollbar {
      width: 10px;
      background: #cccccc;
      border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: gray;
    }

    position: fixed;
    padding: 16px;
    scrollbar-width: '10px';
    scrollbar-color: '#2f97cf #92c8e6';
    cursor: default;
    width: 50%;
    height: 80%;
    background-color: whitesmoke;
    z-index: 28;
    overflow: hidden;
    top: 0;
    right: 0;
    height: 100%;
    //overflow: hidden;
    ////overflow-y: scroll;
    //width: 50%;
    //top: 0;
    //right: 0;
    //z-index: 4444;
    //background: white;
    //position: fixed;
    //height: 100%;
    //padding: 2.5%;

    .content {
      padding-right: 10px;
      padding-left: 10px;
      scrollbar-gutter: stable;
      position: absolute;
      overflow-y: auto;
      margin-right: 5px;
      height: 98%;
      width: 98%;
      text-align: left;

      .people {
        margin-top: 5px;

        .title {
          font-size: 1.5rem;
        }

        .name {
          word-wrap: break-word;
          font-size: 1.5rem;
          word-break: keep-all;
          font-weight: 600;
        }
      }

      .texts {
        font-size: 18px;
        text-align: left;
        padding-top: 16px;
        .text {
          padding-top: 8px;
          overflow-wrap: break-word;
        }
      }
    }
  }

  .info-left-leave-active,
  .info-left-enter-active {
    transition: all 0.5s 0s linear;
  }
  .info-left-leave-to,
  .info-left-enter {
    transform: translateX(-50vw);
    opacity: 0;
  }
  #exit {
    cursor: pointer;
    top: calc(1080px * 0.01);
    right: calc(1080px * 1.69);
    width: calc(1080px * 0.05);
    height: calc(1080px * 0.05);
    position: fixed;
    border: none;
    background-color: #e83e8c;
    margin-right: 22px;
    margin-top: 22px;
    border-radius: 50%;
    display: flex;
    padding: 0;
    z-index: 22;
    svg {
      width: 100%;
      height: 100%;
    }
    path {
      fill: rgb(255, 255, 255);
      transition: all 0.4s ease;
    }
    &:hover {
      path {
        d: path('M16,16 8,8z M16,8 8,16z');
      }
    }
  }
}
</style>
